import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { CURRENCY_SYMBOL } from 'constants/enums';
import i18n from 'i18n/config';

import { USER_JOURNEY_CARDS } from './UserJourneyCard.types';

const USER_JOURNEY_CARDS_LEVEL_INDIA: Omit<
  Record<USER_JOURNEY_CARDS, number>,
  USER_JOURNEY_CARDS.TRADE
> = {
  kyc: 0,
  add_bank: 1,
  deposit: 2,
  '30_days_journey': 3,
};

const USER_JOURNEY_CARDS_LEVEL_GLOBAL: Omit<
  Record<USER_JOURNEY_CARDS, number>,
  USER_JOURNEY_CARDS.ADD_BANK
> = {
  kyc: 0,
  deposit: 1,
  trade: 2,
  '30_days_journey': 3,
};

const USER_JOURNEY_CARDS_LEVEL: Partial<Record<USER_JOURNEY_CARDS, number>> =
  IS_INDIAN_EXCHANGE ? USER_JOURNEY_CARDS_LEVEL_INDIA : USER_JOURNEY_CARDS_LEVEL_GLOBAL;

const DAYS_ALLOWED_BETWEEN_KYC_AND_OFFER_CLAIM = IS_INDIAN_EXCHANGE ? 45 : 30;

const COMPLETE_30_DAY_CARD_CONSTANTS = {
  BONUS_AMOUNT: IS_INDIAN_EXCHANGE
    ? `${CURRENCY_SYMBOL.INR}2500`
    : `${CURRENCY_SYMBOL.USD}100`,
  DAYS: 45,
} as const;

const CARD_LEVELS_TEXT = [
  {
    id: 0,
    name: USER_JOURNEY_CARDS.KYC,
    text: i18n.t('markets:userJourneyCards.completeIdentityVerification'),
    mobileText: i18n.t('markets:userJourneyCards.idVerification'),
  },
  {
    id: 1,
    name: USER_JOURNEY_CARDS.ADD_BANK,
    text: i18n.t('markets:userJourneyCards.addBankAccount'),
    mobileText: i18n.t('markets:userJourneyCards.addBankAcc'),
  },
  {
    id: IS_INDIAN_EXCHANGE ? 2 : 1,
    name: USER_JOURNEY_CARDS.DEPOSIT,
    text: IS_INDIAN_EXCHANGE
      ? i18n.t('markets:userJourneyCards.makeADeposit')
      : i18n.t('markets:userJourneyCards.depositBuyCrypto'),
    mobileText: IS_INDIAN_EXCHANGE
      ? i18n.t('markets:userJourneyCards.desposit')
      : i18n.t('markets:userJourneyCards.buyCrypto'),
  },
  {
    id: 2,
    name: USER_JOURNEY_CARDS.TRADE,
    text: i18n.t('markets:userJourneyCards.makeFirstTrade'),
    mobileText: i18n.t('markets:userJourneyCards.trade'),
  },
  {
    id: 3,
    name: USER_JOURNEY_CARDS.THIRTY_DAYS,
    text: IS_INDIAN_EXCHANGE
      ? i18n.t('markets:userJourneyCards.complete30DayOffer_india')
      : i18n.t('markets:userJourneyCards.complete30DayOffer'),
    mobileText: IS_INDIAN_EXCHANGE
      ? i18n.t('markets:userJourneyCards.welcomeOffer')
      : i18n.t('markets:userJourneyCards.firstXDayOffer', {
          offerDays: COMPLETE_30_DAY_CARD_CONSTANTS.DAYS,
        }),
  },
].filter(level => {
  if (IS_INDIAN_EXCHANGE && level.name === USER_JOURNEY_CARDS.TRADE) return false;
  if (!IS_INDIAN_EXCHANGE && level.name === USER_JOURNEY_CARDS.ADD_BANK) return false;
  return true;
});

export {
  USER_JOURNEY_CARDS_LEVEL,
  CARD_LEVELS_TEXT,
  DAYS_ALLOWED_BETWEEN_KYC_AND_OFFER_CLAIM,
  COMPLETE_30_DAY_CARD_CONSTANTS,
};
